import React, { useState, useEffect } from "react";
import { FaUniversity, FaEdit, FaSave, FaSyncAlt } from "react-icons/fa";
import "./AdminBalance.css";
import { Link } from "react-router-dom";
const BRANCH_LIST_API = `https://${process.env.REACT_APP_API_KEY_AUTH_BRANCH}.execute-api.ap-south-1.amazonaws.com/default/createBranch`;
const BALANCE_API =
  "https://nqf7kfb2ag.execute-api.ap-south-1.amazonaws.com/default/balanceUpdate";

export default function AdminBalanceManager() {
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [currentData, setCurrentData] = useState(null);
  const [newBalance, setNewBalance] = useState("");
  const [loading, setLoading] = useState(false);

  // 1. Fetch All Available Branches
  const fetchBranches = async () => {
    try {
      const res = await fetch(BRANCH_LIST_API);
      const data = await res.json();
      setBranches(data.branches || []);
    } catch (err) {
      console.error("Error fetching branches", err);
    }
  };

  // 2. Fetch Specific Balance from balanceTable
  const fetchBalanceDetails = async (branchId) => {
    if (!branchId) return;
    setLoading(true);
    try {
      // We use the GET logic we built in the Lambda
      const res = await fetch(
        `${BALANCE_API}?id=${branchId}&branchName=${branchId}`,
      );
      const data = await res.json();
      setCurrentData(data);
      setNewBalance(data.currentBalance || 0);
    } catch (err) {
      alert("Could not fetch balance");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  // 3. Update/Override Balance (The "Reset" Logic)
  const handleOverride = async () => {
    if (
      !window.confirm(
        "WARNING: This will manually overwrite the branch balance. Continue?",
      )
    )
      return;
    setLoading(true);
    try {
      // To "Reset", we calculate the difference between NEW and OLD
      // and send it as an adjustment, or update your Lambda to support "SET" action.
      // Assuming our Lambda handles "ADD" and "REDUCE", we calculate the delta:
      const oldVal = Number(currentData.currentBalance || 0);
      const newVal = Number(newBalance);
      const diff = newVal - oldVal;

      await fetch(BALANCE_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: selectedBranch,
          branchName: selectedBranch,
          amount: Math.abs(diff),
          action: diff > 0 ? "ADD" : "REDUCE",
        }),
      });

      alert("Balance Corrected Successfully!");
      fetchBalanceDetails(selectedBranch);
    } catch (err) {
      alert("Update Failed");
    }
    setLoading(false);
  };

  return (
    <div className="admin-balance-container">
      <header className="admin-header">
        <h2>
          <FaUniversity /> Branch Balance Administration
        </h2>
        <Link to="/">
          <button className="Branch-nav">Back to Admin Home</button>
        </Link>
      </header>

      {/* --- MANAGE EXISTING SECTION --- */}
      <div className="manage-card">
        <label>Select Branch to Audit:</label>
        <select
          value={selectedBranch}
          onChange={(e) => {
            setSelectedBranch(e.target.value);
            fetchBalanceDetails(e.target.value);
          }}
        >
          <option value="">-- Choose Branch --</option>
          {branches.map((b) => (
            <option key={b.id} value={b.id}>
              {b.id} - {b.branchName}
            </option>
          ))}
        </select>

        {currentData && (
          <div className="audit-details">
            <div className="stat-row">
              <span>Current System Balance:</span>
              <strong
                className={currentData.currentBalance < 0 ? "neg" : "pos"}
              >
                ₹{currentData.currentBalance?.toLocaleString()}
              </strong>
            </div>

            <div className="override-box">
              <h4>
                <FaEdit /> Manual Balance Correction
              </h4>
              <p>
                Enter the actual physical cash amount to synchronize the system:
              </p>
              <input
                type="number"
                value={newBalance}
                onChange={(e) => setNewBalance(e.target.value)}
              />
              <button
                className="btn-save"
                onClick={handleOverride}
                disabled={loading}
              >
                <FaSave /> Overwrite & Sync Balance
              </button>
            </div>
          </div>
        )}
      </div>

      {loading && (
        <div className="loader-overlay">
          <FaSyncAlt className="spin" /> Updating Books...
        </div>
      )}
    </div>
  );
}
